var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row pt-3"},[_c('HistoryComponent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }